import React from 'react';
import { isChunkLoadError, recoverFromChunkError } from '../lib/chunkRecovery';

// ─────────────────────────────────────────────────────────────────────────
// 앱 맨 바깥 안전망. 여기까지 올라온 오류는 전에는 받는 곳이 없어 화면이 통째로 하얗게 됐다.
//
//  - 조각을 못 받은 것(배포 사이에 열려 있던 화면) → 한 번 새로고침(lib/chunkRecovery)
//  - 인터넷이 끊겨 못 받은 것 → 연결을 확인하라고 말하고 버튼
//  - 그 밖의 오류 → 무슨 일인지 한 줄 + 새로고침 버튼(하얀 화면 대신)
// ─────────────────────────────────────────────────────────────────────────

const MESSAGES = {
  reload: { title: '새 버전을 불러오는 중입니다', body: '잠시만 기다려 주세요.' },
  stale: { title: '새 버전이 올라왔습니다', body: '새로고침하면 이어서 쓸 수 있습니다.' },
  offline: { title: '인터넷 연결이 끊겼습니다', body: '연결을 확인한 뒤 새로고침해 주세요.' },
  other: { title: '화면을 그리다 문제가 생겼습니다', body: '새로고침하면 대개 다시 됩니다.' },
};

export function RecoveryScreen({ kind }) {
  const m = MESSAGES[kind] || MESSAGES.other;
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh', width: '100%', boxSizing: 'border-box', display: 'flex',
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 14,
        padding: 24, background: '#0c0f1a', color: '#e5e7eb', textAlign: 'center',
        fontFamily: 'Pretendard, system-ui, sans-serif',
      }}
    >
      <div style={{ fontSize: 18, fontWeight: 700 }}>{m.title}</div>
      <div style={{ fontSize: 14, color: '#94a3b8' }}>{m.body}</div>
      {kind !== 'reload' && (
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            marginTop: 6, padding: '9px 20px', borderRadius: 8, border: '1px solid #475569',
            background: '#1e293b', color: '#e5e7eb', fontSize: 14, fontWeight: 600, cursor: 'pointer',
          }}
        >
          새로고침
        </button>
      )}
    </div>
  );
}

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { kind: null };
  }

  static getDerivedStateFromError(err) {
    // 여기선 판정만 — 새로고침(부작용)은 componentDidCatch 에서
    return { kind: isChunkLoadError(err) ? 'reload' : 'other' };
  }

  componentDidCatch(err) {
    if (!isChunkLoadError(err)) return;
    const action = recoverFromChunkError();
    if (action !== 'reload') this.setState({ kind: action });
  }

  render() {
    return this.state.kind ? <RecoveryScreen kind={this.state.kind} /> : this.props.children;
  }
}
